// extracted by mini-css-extract-plugin
export var childrenContainer = "_16-0";
export var virtualScrollArea = "_16-1";